import { defineComponent as _defineComponent } from 'vue'
import { ref, Ref } from 'vue';
import { useClickOutside } from '@/composables/clickOutside';
import ColorSelector from '../ColorSelector.vue';
import CInput from '@/components/shared/CInput';
import CButton from '@/components/shared/CButton';
import { ColorPropertyType } from './types';
import type { FontColorOption } from '@/typings/customilyElements/canvasElements';
import type { ColorObject } from '@/typings/libraries';

interface Props {
    label: string;
    configKey: ColorPropertyType;
    color?: ColorObject;
    disabled?: boolean;
    highlightStrokeEnabled?: boolean;
    highlightStrokeWidth?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ColorPropertyItem',
  props: {
    label: null,
    configKey: null,
    color: null,
    disabled: { type: Boolean, default: false },
    highlightStrokeEnabled: { type: Boolean, default: false },
    highlightStrokeWidth: { default: 0 }
  },
  emits: ["color-selected", "toggle-highlight-stroke", "update-stroke-width"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'color-selected', color: FontColorOption): void;
    (e: 'toggle-highlight-stroke'): void;
    (e: 'update-stroke-width', value: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { label: string, configKey: ColorPropertyType, color?: ColorObject, disabled: boolean, highlightStrokeEnabled: boolean, highlightStrokeWidth: number };



const isHighlightStroke = props.configKey === ColorPropertyType.HighlightStrokeColor;



const pickerRef: Ref<HTMLElement | undefined> = ref();

const { clickOutsideActive } = useClickOutside(
    pickerRef,
    () => {
        clickOutsideActive.value = false;
    },
    false
);

const toggleColorPicker = () => {
    clickOutsideActive.value = !clickOutsideActive.value;
};

const onColorSelected = (color: FontColorOption) => {
    emit('color-selected', color);
    toggleColorPicker();
};

const onStrokeWidthUpdate = (value: number | string) => {
    emit('update-stroke-width', typeof value === 'number' ? value : parseFloat(value) || 0);
};

const colorHex = () => props.color?.hex || '';

return { __sfc: true,props, isHighlightStroke, emit, pickerRef, clickOutsideActive, toggleColorPicker, onColorSelected, onStrokeWidthUpdate, colorHex, ColorSelector, CInput, CButton }
}

})